import { usGameKeyForBoardKey } from '@/lib/polymarketUs/gameMapping';
import type { TradeIntent } from '../ValueDashboard/GameDetailPanel';
import type { GameRow } from '../ValueDashboard/types';

/** Key reshaping may find a row, but only execution identity may adopt it.
 * A missing live book never licenses the click-time price snapshot. */
export function exactLiveCardGame(
  candidate: GameRow | null | undefined,
  snapshot: GameRow,
  intent: TradeIntent,
): GameRow | null {
  if (!candidate) return null;
  // #1006 — a US intent trades no K/P book: the US tab joins its market by the
  // canonical game, so only that exact game may replace the snapshot. The key
  // orders teams by code, not away/home, so the slots are checked too: the
  // intent's side names a slot, and a swap would flip the outcome it opens.
  if (intent.polymarketUs) {
    const usKey = usGameKeyForBoardKey(snapshot.key);
    return usKey !== null && usGameKeyForBoardKey(candidate.key) === usKey
      && candidate.awayCode === snapshot.awayCode && candidate.homeCode === snapshot.homeCode ? candidate : null;
  }
  const before = snapshot[intent.venue]?.[intent.side];
  const after = candidate[intent.venue]?.[intent.side];
  if (!before || !after) return null;
  if (Boolean(before.nativeSideInverted) !== Boolean(after.nativeSideInverted)) return null;
  if (intent.venue === 'kalshi') {
    return before.marketTicker && after.marketTicker === before.marketTicker ? candidate : null;
  }
  // Both outcome tokens constrain the book because its YES/NO toggle remains
  // available. A missing token cannot certify an executable replacement.
  if (!before.tokenId && !before.noTokenId) return null;
  for (const field of ['tokenId', 'noTokenId', 'conditionId'] as const) {
    if (before[field] && before[field] !== after[field]) return null;
  }
  return candidate;
}
